// src/utils/RequireAuth.tsx
import { UserRoleEnum } from 'app/services/user';
import { Outlet } from 'react-router';
import { GoToHomePage, useAuth } from './AuthProvider';

export function ProtectedRoleRoute({
  roles,
}: {
  roles: (
    | UserRoleEnum.CLIENT
    | UserRoleEnum.ACCOUNTANT
    | UserRoleEnum.ADMIN
    | undefined
  )[];
}) {
  const { role } = useAuth();

  if (!role) return null;
  return roles.includes(role) ? <Outlet /> : <GoToHomePage />;
}

function RequireAuth({ children }: { children: JSX.Element }) {
  return children;
}

export default RequireAuth;
